import React from "react";
import backIcon from "../../Assets/images/blackBackIcon.png";

const BackButton = ({ label = "Back" }) => (
  <div>
    <button
      type="button"
      aria-label={label}
      onClick={() => window.history.back()}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "4px 0",
        color: "#333333",
        background: "transparent",
        border: "none",
        cursor: "pointer",
        fontSize: "14px",
        fontWeight: "500",
      }}
    >
      <img src={backIcon} alt="" style={{ width: "10px", height: "16px" }} />
      {label}
    </button>
  </div>
);

export default BackButton;
